import { Card, Typography, Box, Chip, Grid } from '@mui/material';
import config from 'config';
import DashboardAllInstListCard from './DashboardAllInstListCard';
import DashboardParticipantCard from './DashboardParticipantCard';

function DashboardYKUzmanDesign({ instCounts = [], participantList = [] }) {
    const institutions = config.institutions || [];

    const mergedData = institutions.map((inst) => {
        const row = instCounts.find((x) => x.inst === inst.inst) || {};
        return {
            ...inst,
            finishedMeetingCount: row.finishedMeetingCount || 0,
            ongoingMeetingCount: row.ongoingMeetingCount || 0,
        };
    });

    const totalFinished = mergedData.reduce((acc, x) => acc + (x.finishedMeetingCount || 0), 0);
    const totalOngoing = mergedData.reduce((acc, x) => acc + (x.ongoingMeetingCount || 0), 0);

    return (
        <>
            <Card
                sx={{
                    background: 'linear-gradient(120deg, #FAFBFC 0%, #F9FAFB 40%, #FAFBFC 100%)',
                    borderRadius: 3,
                    boxShadow: 3,
                    p: 2,
                    mb: 1,
                    border: '1px solid rgba(148,163,184,0.25)',
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        mb: 2,
                        gap: 2,
                    }}
                >
                    <Box>
                        <Typography variant="h6" sx={{ color: '#111827', mt: 0.5 }}>
                            Tüm Kurumların Toplantı Özeti
                        </Typography>
                    </Box>

                    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                        <Chip
                            size="small"
                            label={`Tamamlanan: ${totalFinished}`}
                            sx={{
                                bgcolor: '#E0F2FE',
                                color: '#0369A1',
                                fontWeight: 600,
                                fontSize: 11,
                            }}
                        />
                        <Chip
                            size="small"
                            label={`Devam Eden: ${totalOngoing}`}
                            sx={{
                                bgcolor: '#FEF3C7',
                                color: '#92400E',
                                fontWeight: 600,
                                fontSize: 11,
                            }}
                        />
                    </Box>
                </Box>

                <DashboardAllInstListCard instCounts={instCounts} />
            </Card>

            {participantList && participantList.length > 0 && (
                <Grid container spacing={1} sx={{ mt: 0 }}>
                    <Grid item xs={12}>
                        <DashboardParticipantCard mainData={participantList} />
                    </Grid>
                </Grid>
            )}
        </>
    );
}

export default DashboardYKUzmanDesign;


